import { render, staticRenderFns } from "./AuthLogo.vue?vue&type=template&id=671ca606"
import script from "./AuthLogo.vue?vue&type=script&lang=js"
export * from "./AuthLogo.vue?vue&type=script&lang=js"
import style0 from "./AuthLogo.vue?vue&type=style&index=0&id=671ca606&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports